import Vue from 'vue'
import ElementUI from 'element-ui';
import './scss/main.scss';
import './scss/custom.scss';
import AMap from 'vue-amap'
import locale_en from 'element-ui/lib/locale/lang/en'
import locale_cn from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/display.css'
import echarts from 'echarts'
import i18n from './i18n/i18n'
import '../static/css/lato.css'
import ('../static/css/HYQiHei.css')
import exportPdf from './components/exportPdf'
import exportPdfCrossCity from './components/exportPdfCrossCity'
import exportExcel from './components/exportExcel'
import exportHubTemplateExcel from './components/exportHubTemplateExcel'
import exportExcelCrossCity from './components/exportExcelCrossCity';
//import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import VueApexCharts from 'vue-apexcharts'
import store from './store/index'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '../static/css/select-vue-component.css'
import App from './App.vue'
import router from './router/index.js'
import Ionicons from 'vue-ionicons/dist/ionicons.js'
import 'vue-ionicons/ionicons.scss'
import axios from 'axios';

Vue.config.productionTip = false;
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueMeta)
Vue.use(store)
// 引入vue-amap
Vue.use(ElementUI, {
  locale_cn
})
Vue.use(AMap);
Vue.use(echarts);
Vue.use(exportPdf);
Vue.use(exportPdfCrossCity);
Vue.use(exportExcel);
Vue.use(exportHubTemplateExcel);
Vue.use(exportExcelCrossCity);
Vue.use(VueApexCharts)
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德的key
  key: 'd00ecfa872d742bf6fd1a3b5acaeeb6c',
  // 插件集合
  plugin: ['AMap.MapType'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});

// Configuration VueAnalytics
// Vue.use(VueAnalytics, {
//   id: 'UA-163659188-2',
//   router
// })

Vue.use(Ionicons)

// apex chartjs
Vue.component('apexchart', VueApexCharts)

//ignore ion unknown element warning
Vue.config.ignoredElements = [/^ion-/]

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(
  config => {
    //  let slidingToken = JSON.parse(sessionStorage.getItem("SlidingToken"));
    //   if (slidingToken) {
    //       config.headers = Object.assign({
    //           Authorization: `Bearer ${slidingToken}`
    //       }, config.headers);
    //   }
      config.withCredentials = true
      return config;
  }
)

axiosInstance.interceptors.response.use(
    response => {
      if (response.status === 200 || response.status === 201) {
        // if (response.data && response.data.sliding_token) {
        //   sessionStorage.setItem("SlidingToken", JSON.stringify(response.data.sliding_token));
        // }
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
            case 400:
            //do something
                break;
            
            case 401:
                //alert("session expired");
                router.push({ path: './', query: { logout: true } })
                break;
            case 403:
                let lang = JSON.parse(sessionStorage.getItem("lang"));
                sessionStorage.clear()
                sessionStorage.setItem("lang", JSON.stringify(lang))
                router.push({
                  path: '/', query: { expired: true } 
                });
                break;
            case 404:
                alert('page not exist');
                break;
            case 500:
                router.push({
                  path: '/error'
                });
                break;
            case 501:
                break;
            case 502:
                break;
            }
        return Promise.reject(error.response);
      }
    }
);

Vue.prototype.$axios = axiosInstance
Vue.prototype.$echarts = echarts


new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
